// src/Data/Education.js
export const Educations = [
  {
    id: 1,
    videoId: "LKoMr0z9MzQ", // UIS
    title: "M.S. in Data Analytics",
    duration: "2024 – 2026",
    institution: "University of Illinois Springfield (UIS), USA",
  },
  {
    id: 2,
    videoId: "wnSsno0iz9A", // TKR (updated)
    title: "B.Tech in Computer Science Engineering",
    duration: "2019 – 2023",
    institution: "TKR College of Engineering & Technology, Hyderabad, India",
  },
];
